// extracted by mini-css-extract-plugin
module.exports = {"office__city":"Office_office__city__a729T","office__location":"Office_office__location__2C2cG","office__address":"Office_office__address__3M5dZ"};